import type { FunctionComponent } from 'react';

import { EmailToBoardTestIds } from '@trello/test-ids';

import styles from './EmailToBoardButtonSkeleton.less';

export const EmailToBoardButtonSkeleton: FunctionComponent = () => {
  return (
    <div data-testid={EmailToBoardTestIds.EmailToBoardButtonSkeleton}>
      <div className={styles.row} />
    </div>
  );
};
